import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchProducts = (params = {}) =>
  axios.get(`${API}/products`, { params }).then((r) => r.data);

export const fetchProduct = (id) =>
  axios.get(`${API}/products/${id}`).then((r) => r.data);

export const fetchRelated = (id) =>
  axios.get(`${API}/products/${id}/related`).then((r) => r.data);

export const fetchReviews = () => axios.get(`${API}/reviews`).then((r) => r.data);

export const placeOrder = (payload) =>
  axios.post(`${API}/orders`, payload).then((r) => r.data);

export const sendContact = (payload) =>
  axios.post(`${API}/contact`, payload).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  axios.post(`${API}/newsletter`, { email }).then((r) => r.data);

const authHeader = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("rvi_admin_token")}` } });

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);

export const adminMe = () => axios.get(`${API}/auth/me`, authHeader()).then((r) => r.data);

export const adminGetStats = () => axios.get(`${API}/admin/stats`, authHeader()).then((r) => r.data);

export const adminGetOrders = () => axios.get(`${API}/admin/orders`, authHeader()).then((r) => r.data);

export const adminUpdateOrderStatus = (id, status) =>
  axios.patch(`${API}/admin/orders/${id}`, { status }, authHeader()).then((r) => r.data);

export const adminCreateProduct = (p) => axios.post(`${API}/admin/products`, p, authHeader()).then((r) => r.data);

export const adminUpdateProduct = (id, p) => axios.put(`${API}/admin/products/${id}`, p, authHeader()).then((r) => r.data);

export const adminDeleteProduct = (id) => axios.delete(`${API}/admin/products/${id}`, authHeader()).then((r) => r.data);

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail?.msg || String(detail);
};

export const createRazorpayOrder = (order_id) =>
  axios.post(`${API}/payments/razorpay/order`, { order_id }).then((r) => r.data);

export const verifyRazorpayPayment = (payload) =>
  axios.post(`${API}/payments/razorpay/verify`, payload).then((r) => r.data);

export const cancelRazorpayOrder = (order_id) =>
  axios.post(`${API}/payments/razorpay/cancel`, { order_id }).then((r) => r.data);

export const adminUploadImage = (file) => {
  const data = new FormData();
  data.append("file", file);
  return axios.post(`${API}/admin/upload`, data, authHeader()).then((r) => r.data);
};

export const subscribeMobile = (phone) =>
  axios.post(`${API}/subscribers`, { phone, consent: true }).then((r) => r.data);

export const adminGetSubscribers = () =>
  axios.get(`${API}/admin/subscribers`, authHeader()).then((r) => r.data);

export const fetchOfferBanner = () =>
  axios.get(`${API}/settings/offer-banner`).then((r) => r.data);

export const adminSaveOfferBanner = (items) =>
  axios.put(`${API}/admin/settings/offer-banner`, { items }, authHeader()).then((r) => r.data);

export const fetchAnnouncementBar = () =>
  axios.get(`${API}/settings/announcement-bar`).then((r) => r.data);

export const adminSaveAnnouncementBar = (items) =>
  axios.put(`${API}/admin/settings/announcement-bar`, { items }, authHeader()).then((r) => r.data);

export const fetchHero = () =>
  axios.get(`${API}/settings/hero`).then((r) => r.data);

export const adminSaveHero = (data) =>
  axios.put(`${API}/admin/settings/hero`, data, authHeader()).then((r) => r.data);

export const fetchHomeVideo = () =>
  axios.get(`${API}/settings/home-video`).then((r) => r.data);

export const adminSaveHomeVideo = (url) =>
  axios.put(`${API}/admin/settings/home-video`, { url }, authHeader()).then((r) => r.data);

export const WHATSAPP_NUMBER = "919449909269";
export const INSTAGRAM_URL = "https://www.instagram.com/rv_ilkal_sarees";
export const FACEBOOK_URL = "https://www.facebook.com/Ilkalsareestore";
export const PHONE = "9449909269";
export const EMAIL = "rvilkalsarees@gmail.com";
export const MAPS_URL = "https://maps.app.goo.gl/N6QkKNrpiEbXoDav5";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const SHOP_COLORS = [
  { name: "Red", hex: "#A61B1B" },
  { name: "Maroon", hex: "#6B1C23" },
  { name: "Black", hex: "#1A1A1A" },
  { name: "Green", hex: "#2E5E3A" },
  { name: "Blue", hex: "#2C4A7C" },
  { name: "Pink", hex: "#D76A8A" },
  { name: "Purple", hex: "#6B3F7A" },
  { name: "Yellow", hex: "#D9A821" },
  { name: "Orange", hex: "#C96A2B" },
  { name: "Cream", hex: "#EFE3CC" },
];

export const CATEGORIES = [
  { slug: "traditional", name: "Traditional Ilkal Sarees", img: "/category-traditional.jpg" },
  { slug: "cotton", name: "Ilkal Cotton Sarees", img: "/category-cotton.jpg" },
  { slug: "silk", name: "Ilkal Silk Sarees", img: "/category-silk.jpg" },
  { slug: "patteda-anchu", name: "Patteda Anchu Sarees", img: "/category-patteda.jpg" },
  { slug: "badge:new", name: "New Arrivals", img: "/category-new.jpg" },
  { slug: "badge:bestseller", name: "Best Sellers", img: "/category-bestsellers.jpg" },
  { slug: "daily", name: "Daily Wear", img: "/category-daily.jpg" },
  { slug: "premium", name: "Premium Collection", img: "/category-premium.jpg" },
];

export const FABRICS = ["Pure Cotton", "Viscose Cotton", "Handloom Cotton", "Cotton-Silk", "Pure Silk", "Silk Tissue"];
export const OCCASIONS = ["Daily Wear", "Office", "Festive", "Wedding", "Party"];

export const IMGS = {
  hero: "https://images.pexels.com/photos/36120203/pexels-photo-36120203.jpeg?auto=compress&cs=tinysrgb&w=1600",
  weave: "/heritage-weave.jpg",
  texture: "/texture-ilkal.jpg",
  weddingBanner: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?q=80&w=1600&auto=format&fit=crop",
};
